import { render, staticRenderFns } from "./InvoiceChildren.vue?vue&type=template&id=3e2c3cde&scoped=true"
import script from "./InvoiceChildren.vue?vue&type=script&lang=js"
export * from "./InvoiceChildren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2c3cde",
  null
  
)

export default component.exports